/**
 * 配置信息
 *
 * @author Shigq
 * @date 2020/12/3 19:10
 * @description 2个子配置，通用配置 | 网络配置导出
 */
const { config } = require('@libs/ui')
const setting = require('./setting.config')
const net = require('./net.config')

const remoteConfig = {
  ...config.componentConfig,
  ...config.fileConfig,
  ...config.settingConfig
}

const localConfig = {
  ...net,
  ...setting
}

const instance = {
  ...remoteConfig,
  ...localConfig
}

module.exports = instance
